module.exports = __webpack_public_path__ + "media/src/img/sms_operators-39ca831a63741920acedd31569c90b6c.svg";